
import React, { useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
//import topLogo  from "../../../assets/main-logo/coaLogo.svg"
import {  getCurrentDateTime,capitalizeWords, getPrintUnit, formatDateMoment } from '../../../utils/utils';

const COAPrint = ({ open, onClose, printData={}, patientInfo={},isVisible=false}) => {
  const topLevel = patientInfo?.patient_information?.print_details?.find((it) => it?.label_type == '3')
  const topLogo = topLevel?.brand_logo;
  const brand_name = topLevel?.brand_name;
   const address = topLevel?.org_description || '22WJ+JV7, S Central Rd, MIDC Industrial Area, Shiravane, Nerul, Navi Mumbai, Maharashtra 400705, www.immunoact.com';

  const printContentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    content: () => printContentRef.current,
    onAfterPrint: onClose,
    removeAfterPrint: true,
  });
 
    useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        if (printContentRef.current) {
          reactToPrintFn();
        }
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [open]);
                                          
  const {
   printPatientInfo,
  } = printData || {};
  return (
        <div style={{ display: isVisible ? 'block' : 'none' }}>
      <div ref={printContentRef}>
      <div style={{ 
        width: '210mm',
        minHeight: '297mm',
        padding: '15mm',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        fontSize: '10pt',
        backgroundColor: 'white',
        lineHeight: '1.2',
        boxSizing: 'border-box',
        position: "relative"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#2E5598',
            marginBottom: '5px',
            textAlign: "center",
            display: "flex",
            flexDirection: "column"
          }}>
          <img src={topLogo}  style={{margin:"0 auto", maxWidth:"200px",maxHeight: "100px"}} />
          {brand_name || 'NexCAR 19'}
          </div>
          <div style={{
            fontSize: '11px',
            color: '#777',
            lineHeight: '1.4'
          }}>
                       {address}

          </div>
          <div style={{
            borderTop: '2px solid #D8D8D8',
            margin: '15px 0',
            width: '100%'
          }}></div>
          
          {/* Form Title */}
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#000',
            margin: '10px 0'
          }}>
            Certificate of Analysis
          </div>
        </div>
        
        <div style={{ paddingBottom: '50px' }}> {/* Add padding to prevent content overlap with footer */}
              <div>
                {/* Section title */}
                <div className="section-title">Product Information</div>
                
                {/* Rounded box */}
             <div className="section-box">
  <div className="field-grid">
    <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Product Name</div>
      <div className="field-value">
        {printData?.product_name || patientInfo?.product_name} {/* @info added product_name */}
      </div>
    </div>
    <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Batch Number</div>
      <div className="field-value">
        {patientInfo?.batch_no}
      </div>
    </div>
     <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Patient ID</div>
      <div className="field-value">
       {patientInfo?.patientId || printData?.patient_id}
      </div>
    </div>
     <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Manufacturing Date</div>
      <div className="field-value">
       {formatDateMoment(patientInfo?.mfg_date)}
      </div>
    </div>
      <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Expiry Date</div>
      <div className="field-value">
       {formatDateMoment(patientInfo?.expiry_date)}
      </div>
    </div>
    <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Specification No.</div>
      <div className="field-value">
       {printData?.specification_no}
      </div>
    </div>
      <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Storage Conditions</div>
      <div className="field-value">
       {printData?.storage_condition}
      </div>
    </div>
  </div>
</div>

 <div className="section-title">Report</div>
 {/* Test Results Table */}
          <table width="100%" cellSpacing="0" cellPadding="3" style={{ 
            borderCollapse: 'collapse',
          }}>
            <thead>
              <tr>
                <th style={{ 
                  border: '1px solid #EAEBEF',
                  padding: '6px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  width: '10%'
                }}>
                  Sr. No.
                </th>
                <th style={{ 
                  border: '1px solid #EAEBEF',
                  padding: '6px',
                  fontWeight: 'bold',
                  textAlign: 'left',
                  width: '40%'
                }}>
                  Test
                </th>
                <th style={{ 
                  border: '1px solid #EAEBEF',
                  padding: '6px',
                  fontWeight: 'bold',
                  textAlign: 'left',
                  width: '30%'
                }}>
                  Specification
                </th>
                <th style={{ 
                  border: '1px solid #EAEBEF',
                  padding: '6px',
                  fontWeight: 'bold',
                  textAlign: 'left',
                  width: '20%'
                }}>
                  Result
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>1</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>RCL (qPCR)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Negative</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.rcl_qpcr}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>2</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Sterility (culture method/BACTEC)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Negative</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.sterility_culture_method_bactec}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>3</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Multiplex Viral test (PCR)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Negative</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.multiplex_viral_test_pcr}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>4</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Mycoplasma (PCR)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Negative</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.mycoplasma_pcr}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>5</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Appearance</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Milky; no aggregates</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.appearance}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>6</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>CAR surface expression (Flow cytometry)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>TE ≥ 15%</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.car_surface_expression_flow_cytometry}{printData?.car_surface_expression_flow_cytometry? '%':''}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>7</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Cell viability (dye exclusion method)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Viability ≥ 70%</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.cell_viability_dye_exclusion_method}{printData?.cell_viability_dye_exclusion_method? '%':''}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>8</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>CD19 + viable cell detection (Flow cytometry)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Report result</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.cd19_viable_cell_detection_flow_cytometry}{printData?.cd19_viable_cell_detection_flow_cytometry? '%':''}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>9</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Detection of magnetic beads (Microscope)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Residual beads (≤100 beads/3x10^6 cells)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.detection_of_magnetic_beads_microscope}{printData?.detection_of_magnetic_beads_microscope? ' beads/3x10^6 cells':''}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>10</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Endotoxin level</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>≤5 EU/mL</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.endotoxin_level}{getPrintUnit(printData?.endotoxin_level, 'EU/mL')}</td>  {/* @info added getPrintUnit in case to show or hide units -ve unit show only*/}
              </tr>
              <tr>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px', textAlign: 'center' }}>11</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>Vector copy number-VCN (qPCR)</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>≤5.0 copies per cell</td>
                <td style={{ border: '1px solid #EAEBEF', padding: '5px' }}>{printData?.vector_copy_number_vcn_qpcr}{getPrintUnit(printData?.vector_copy_number_vcn_qpcr, ' per cell')}</td>
              </tr>
            </tbody>
          </table>
  <div className="section-title mt-20">Remarks</div>
          <div className="section-box">
  <div className="field-grid">{printData?.remarks}</div>
  </div>
              </div>
          {/* Date Section - Above the footer */}
        <div className="date-section">
          <div className="date-row">
            <div className="date-column">
              <div className="date-label">Submitted By:</div>
              <div className="date-name">{capitalizeWords(printData?.prepared)}{printData?.partially_approved_role ? '('+printData?.partially_approved_role+')':''}</div>
              <div className="date-time">{printData?.partially_approved_at ? getCurrentDateTime(printData?.partially_approved_at):''}</div>
            </div>
            
            <div className="date-column">
              <div className="date-label">Reviewed By:</div>
              <div className="date-name">{capitalizeWords(printData?.reviewed)}
                {printData?.lead_approved_role ? '('+printData?.lead_approved_role+')':''}
               </div>
              <div className="date-time">{printData?.approved_lead_at ? getCurrentDateTime(printData?.approved_lead_at):''}</div>
            </div>
            
            <div className="date-column">
              <div className="date-label">Approved By:</div>
              <div className="date-name">{capitalizeWords(printData?.approved_by)}
                 {printData?.approved_role ? '('+printData?.approved_role+')':''}</div>
              <div className="date-time">{printData?.approved_at ? getCurrentDateTime(printData?.approved_at):''}</div>
            </div>
          </div>
        </div>
        </div>
         
        {/* Fixed Footer at bottom of last page */}
        <div className="footer-section">
          <div className="footer-content">
            <div className="declaration-text">
              This document is system generated and does not require a signature.
            </div>
            <div className="confidential-text">
              Confidential document, property of &lsquo;Immunoadoptive Cell Therapy Private Limited&lsquo;, 
              duplication, disclosure and circulation is strictly prohibited
            </div>
          </div>
          <div className="timestamp-section">
            <span className="timestamp-item">
              Printed on: {getCurrentDateTime()}
            </span>
            <span className="timestamp-item">
              Created On: {printPatientInfo?.created_at ? getCurrentDateTime(printPatientInfo?.created_at):''}
            </span>
          </div>
        </div>
        
      </div>
      
      <style>
        {`
          @page {
            size: A4;
            margin: 2mm;
          }
          
          .page-break {
            page-break-before: always;
            break-before: page;
          }
          
          .print-page {
            font-family: Arial, sans-serif;
            font-size: 14px;
            color: #000;
          }
          
          .head-title {
            text-align: center;
            font-weight: bold;
            color: #3571FF;
            font-size: 25px;
          }
          
          .section-title {
            font-size: 14px;
            font-weight: 700;
            padding: 11px 8px 11px;
            letter-spacing: 0.5px;
            background-color: #EAEBEF;
            border-radius: 10px 10px 0 0;
            margin-bottom: 0;
            border: 1px solid #D8D8D8;
            border-bottom: none;
          }
          
          .section-box {
            background: #f8fafc;
            padding: 16px;
            margin-bottom: 20px;
            border: 1px solid #D8D8D8;
            border-top: none;
            border-radius: 0 0 4px 4px;
          }
          
          .field-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px 24px;
          }
          
          .field-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          
          .field-item.full-width {
            /* This class is kept for backward compatibility */
          }
          
          .field-label {
            font-weight: 600;
            color: #333;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }
          
          .field-value {
            color: #545454;
            background: #ffffff;
            font-size: 12px;
            min-height: 15px;
            word-break: break-word;
          }
          
          .field-value.full-width-value {
            width: 100%;
          }
          
          /* Footer styles */
          .footer-section {
            position: absolute;
            bottom: 15mm; /* Match the page padding */
            left: 15mm;
            right: 15mm;
            margin-top: auto;
          }
          
          .footer-content {
            text-align: center;
            color: #858585;
            font-size: 10px;
            line-height: 1.4;
            margin-bottom: 5px;
          }
          .date-row {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-top:30px;
          }
            .date-label{
            color:#3571FF;
            font-size:10px;
            }
            .date-time{
            color:#A3A3A3;
             font-size:8px;
            }
              .date-name {
            font-size: 11px;
            margin-bottom: 4px;
            color: #545454;
          }
          .declaration-text {
            margin-bottom: 3px;
          }
          
          .confidential-text {
            font-style: italic;
          }
          
          .timestamp-section {
            display: flex;
            justify-content: space-between;
            font-size: 10px;
            color: #858585;
            border-top: 1px solid #e0e0e0;
            padding-top: 5px;
          }
          
          @media print {
            .footer-section {
              position: fixed;
              bottom: 15mm;
              left: 15mm;
              right: 15mm;
            }
            
            .field-value {
              background: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-box {
              background: #f8fafc !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-title {
              background-color: #EAEBEF !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
              .mt-20{
              margin-top:20px;
              }
          }
        `}
      </style>
    </div>
    </div>
  );
};

export default COAPrint;